{
  "slug": "average-iq-in-argentina",
  "title": "IQ promedio en Argentina: qué permiten afirmar los datos",
  "description": "Análisis prudente de las cifras de IQ promedio en Argentina, el muestreo, la comparabilidad entre pruebas y la incertidumbre.",
  "summary": "No existe una cifra nacional única y permanente para Argentina. Las estimaciones dependen de las muestras, las pruebas, los años, los idiomas y los ajustes estadísticos.",
  "category": "Estadísticas de IQ",
  "sections": [
    {
      "heading": "Por qué las fuentes muestran cifras diferentes",
      "paragraphs": [
        "Una investigación puede evaluar estudiantes, voluntarios, participantes en línea o una región, no una muestra representativa de todo el país.",
        "Mezclar edades, años, pruebas e idiomas distintos puede producir una tabla precisa en apariencia pero poco comparable. Algunas fuentes incluso estiman países sin suficientes datos directos."
      ]
    },
    {
      "heading": "Qué revisar antes de confiar en una clasificación",
      "paragraphs": [
        "Comprueba quién participó, cuándo se recogieron los datos, qué prueba y normas se utilizaron, cómo se trató el idioma y cuánta información faltaba.",
        "PISA evalúa competencias educativas concretas y no equivale a un test de IQ individual, aunque algunos resultados de grupo puedan estar relacionados."
      ]
    },
    {
      "heading": "Lo que un promedio nacional no demuestra",
      "paragraphs": [
        "Las distribuciones de los grupos se solapan ampliamente. Una media nacional no determina la capacidad de una persona argentina ni explica por sí sola las causas.",
        "Es preferible utilizar datos transparentes y actuales para hablar de educación, salud y oportunidades sin convertir una estimación discutible en un juicio sobre la población."
      ]
    }
  ],
  "faqs": [
    {
      "question": "¿Cuál es el IQ promedio de Argentina?",
      "answer": "No hay una cifra definitiva que sea válida para todas las fuentes; cambia según muestra, prueba, año y método."
    },
    {
      "question": "¿Se pueden ordenar los países con precisión?",
      "answer": "No sin datos representativos y comparables con incertidumbre visible; muchas tablas populares no cumplen esos requisitos."
    }
  ],
  "related": ["average-iq-by-country", "what-is-the-average-iq", "historical-iq-trends"],
  "sources": [
    {
      "label": "OECD — PISA data and methodology",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ]
}
